/**
 * Returns a valid avatar URL. If the provided URL is empty, null, or broken,
 * falls back to a DiceBear Notionists avatar seeded with the user's ID or name.
 */
export function avatarUrl(url, fallbackSeed = "player") {
  if (url && url.startsWith("http")) return url;
  return `https://api.dicebear.com/7.x/notionists/svg?seed=${encodeURIComponent(fallbackSeed)}&backgroundColor=ffd600,ff3333,2b5cff`;
}
